const BaseComponent = require('base/base-component');

class banner extends BaseComponent {
  constructor () {
    super({
      events: {
        'click .hidebanner': 'closeBanner'
      }
    });
  }
  init () {
    let that = this;
    this.cd = Number(this.$el.find('[name=timer]').val());
    $(document).ready(() => {
      that.countDown = setInterval(() => {
        that.cd--;
        if (that.cd > 0) {
          that.$el.find('.banner-container span').text(that.cd + '秒');
        } else {
          that.$el.animate({
            height: 0
          });
          clearInterval(that.countDown);
        }
      }, 1000);
    });
  }
  closeBanner () {
    this.$el.animate({
      height: 0
    });
    clearInterval(this.countDown);
  }
}
module.exports = banner;
